












































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState ,HellospokeContact,AppSettings} from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import utill from '../../lib/util'; 
import axios from 'axios'; 
import ContactModal from '../Contact_sprint2/Contact_modal.vue';
import ContactTextmessages from  '../Contact_sprint2/Contact_Textmessages.vue';
import ManagingTag from  '../Tag/ManaginTag.vue';
import util from "../../lib/util";

@Component({
  components: {
      RotateSquare2,VueElementLoading,ContactModal,ContactTextmessages,ManagingTag
},
computed: {
...mapState({
  'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
  'User_id': (state: StoreState) => state.dashboard.logger_userid ,
  'FavoirteContact_Count': (state: StoreState) => state.dashboard.FavoirteContact_Count,
   'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
    'tagstatus': (state: StoreState) => state.dashboard.Tag_status,
    'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,   
    'privilege_level':(state: StoreState) => state.account.privilege_level,
  })
 }
})
export default class CONTACTEDIT extends Vue {
  

  data() {
   return {
    loadingg:false,
    is_loading: false,
    selectedDevice: null,
    activetab: 'details',
    editstatus:false,
    submitted: false,
    editemail_status:false,
    SelectedContInf:'',
    imagUploading:false,
    Fav_contact:false,
    Deletemodal:false,
    delet_loader:false,
    contac_tag:[],
    managintab:false,
    clickstatus: false,
    oldtaglist: [],
    taglist:[ ],
   
   }
  }
 
  

 Edicontc_(){
  this.$data.activetab='editcontct';
  this.$data.editstatus=true;
  this.contact_infor();
 // this.$data.SelectedContInf=(this as any).selectedContact;
 }

companyEdicontc_()
{
   this.$data.activetab='editcontct';
  this.$data.editstatus=true;
  this.$data.SelectedContInf=(this as any).selectedContact;
  console.log("stst"+JSON.stringify(this.$data.SelectedContInf))
  this.contact_infor();
}
  handlecustomdd() //type, index
    { 
       // let classstatus = document.querySelector(".mtagclass");
        let tag_svgGreen = document.querySelector(".tag_svgGreen");
        if( tag_svgGreen && this.$data.managintab && !this.$data.clickstatus)
        {
          this.$data.managintab = false;
        }
        else
        {
          this.$data.clickstatus = false;
        }
    
    }


  contact_infor(){
   var User_id=(this as any).User_id;
    var payload =(this as any).selectedContact;
    this.$store.dispatch("ContactInfo", payload).then(r => {
    var conta=r.data.docs[0];
    debugger
    conta.tags1=[];
    this.$data.oldtaglist = conta.taglist;
    const created_tags=(this as any).Tag_list_;
    if(conta.taglist!=undefined){
      created_tags.forEach((e1)=>conta.taglist.forEach((e2)=> {
          if(e1._id === e2){
          conta.tags1.push(e1);
          }
      }
      ));
      }
    debugger

    if(conta.work==undefined ){
     conta.work=[];
    }
    if((typeof conta.address)=="object"){
      conta.address=this.addressLastLine(conta);
    }
    if(conta.Favoritecontact!=undefined && conta.Favoritecontact.length!=0 ){
      conta.Favoritecontact.filter(function (elmt) {
          if(elmt==User_id){
          conta.pvt_cont=true;
          }
          else{
          conta.pvt_cont=false;
          }
      });
      }
    else{
          conta.pvt_cont=false;
      }
      this.$data.editemail_status=false;
      this.$store.commit("CHANGE_SELECTED_CONTACT", conta);
      this.$data.SelectedContInf=conta;
      console.log("contact"+  JSON.stringify(this.$data.SelectedContInf))
      //(this as any).selectedContact;// JSON.parse(JSON.stringify((this as any).selectedContact));;
    });
 }

  addressLastLine(selectedContact) {
   //var selectedContact=(this as any).selectedContact;
      if(selectedContact && selectedContact.address) {
          const line1 = selectedContact.address.line1 ? selectedContact.address.line1 : '';
          const line2 = selectedContact.address.line2 ? selectedContact.address.line2 : '';
          const city = selectedContact.address.city ? selectedContact.address.city : '';
          const state = selectedContact.address.state ? selectedContact.address.state : '';
          const zip = selectedContact.address.zip ? selectedContact.address.zip : '';
           return `${line1} ${line2} ${city} ${state} ${zip}`;
      }
      else {
          return null;
      }
  }
  isNumber(event, message) {
  if (!/\d/.test(event.key) &&  
      (event.key !== "." || /\./.test(message))     
  )  
      return event.preventDefault();  
  }

  addd_work(){
    this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:true});
    this.$data.SelectedContInf.work[0].delet="";
  }

  delete_work(index){
     this.$data.SelectedContInf.work.splice(index, 1);  
  }
  
  workeditdatacheck()
  {
    if(this.$data.SelectedContInf.work.length == 0)
      return false;
     let return_var = false;
     for(let i = 0; i < this.$data.SelectedContInf.work.length; i++)
      if(this.$data.SelectedContInf.work[i].work)
          return_var = true;
     return return_var;
  } 
 
  getColor(user)
    {  
      return utill.userColor(user.tag , user._id);
      // return utill.userColor(user);
    }

  editworkdatacheck(index = -1)
  {
    let faultyindex = [];
    if(this.$data.SelectedContInf.work.length == 0)
      return false;
    let return_var = false;
     for(let i = 0; i < this.$data.SelectedContInf.work.length; i++)
       if(!(this.validatePhoneNumber(this.$data.SelectedContInf.work[i].work) != "Invalid number"))
       {
          return_var = true;
           faultyindex.push(i);
       }
    return {type: return_var, ids: faultyindex, position: faultyindex.indexOf(index)};
  }
 
  validatePhoneNumber(phoneNumber: any) {
    if(!phoneNumber) return true;
     if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            } 
            if(phoneNumber.length != 10) return "Invalid number";      
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
              this.$data.Number_status = false;
                    console.log("The phone number " + phoneNumber + " could not be parsed");
                return "Invalid number";
            }           
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }
 
  //Add to favorite contact
  AddtoFavoritecont(){
   this.$data.loadingg=true;
   var contact_info=(this as any).selectedContact;
   this.$store.dispatch('addtoFavoritContac', contact_info._id).then(r => {
   var USERID=(this as any).User_id; 
    var conta=r.data.doc;
     this.$data.loadingg=false;
    conta=this.Enable_Disable_fav(conta);
    this.$store.commit("CHANGE_SELECTED_CONTACT", conta ); 
    this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count+1);
    this.$emit('updatecontact', 'UpdateContactInfo');
    
      }).catch(() => {
        });
  }

  //Remove from favorite contact
  RemoveFavorite(){
   this.$data.loadingg=true;
   var contact_info=(this as any).selectedContact;
   var USERID=(this as any).User_id;
   this.$store.dispatch('removeFavoritContac', contact_info._id).then(r => {
    var conta=r.data.doc;
     this.$data.loadingg=false;
    conta=this.Enable_Disable_fav(conta);
    this.$store.commit("CHANGE_SELECTED_CONTACT", conta ); 
    this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count-1);
    this.$emit('updatecontact', 'UpdateContactInfo');
    }).catch(() => {
   });
  }

  Edit_DeleteContact(){
      this.$data.delet_loader=true;
      var data=(this as any).selectedContact;
      this.$store.dispatch('deleteContact', { id: data._id, rev:data._rev}) .then(r => {
        this.$data.Deletemodal=false;
        this.$data.delet_loader=false;
        this.$emit('editcontactclose' ,'delet_refresh');
        })
        .catch(() => {  });
  }

  Enable_Disable_fav(conta){
  var USERID=(this as any).User_id;
  if(conta.Favoritecontact!=undefined && conta.Favoritecontact.length!=0 ){
      conta.Favoritecontact.filter(function (elmt) {
          if(elmt==USERID){
          conta.pvt_cont=true;
          }
          else{
          conta.pvt_cont=false;
          }
      });
      }
      else{
          conta.pvt_cont=false;
      }
      return conta;
  }

  fileUploaded(files) {
       // alert(JSON.stringify(files))
    var FileSize=files[0].size;
    var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
    if(Max_fileSize>4)
      {
          alert('Attachment may not exceed 5MB.');
      }
    else{
      this.$data.sendingImage = true;
      (this as any).imagUploading=true;
      let formData = new FormData();
      JSON.parse(JSON.stringify((this as any).selectedContact))
      formData.append('file', files[0]);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
      axios.post( `${AppSettings.API_HOST}uploadContactImage`,
          formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
          }
      ).then(r => {
         (this as any).selectedContact.imageUrl = this.$data.SelectedContInf.imageUrl=r.data.imageurl;
          this.$store.dispatch('submitContactChanges', (this as any).selectedContact).then(r => {
            debugger
              (this as any).imagUploading=false;
          this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
      }).catch(() => {
        (this as any).imagUploading=false;
        this.$data.sendingImage = false;
            this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
        });
      })
      .catch(r => {
          this.$data.sendingImage = false;
          (this.$refs.fileInput as any).value = null;
          console.log('failed', r);
      });
           }
  }
  validateEmail(email: any) {
      //Breakdown of this Regex can be found here:
      //https://www.w3resource.com/javascript/form/email-validation.php
      //Seems to cover most all cases.
        const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if(!re.test(email)) {
              return false;
          }
      return true;
    }

   
  mange_tag(tags_contac,type = 'open'){
     setTimeout(function(){
      this.$store.commit('MANAGING_TAG','Contact_tag');
    if(type == "open")
    {
      this.$data.managintab = true;  
    }
    else
    {
      this.$data.managintab = false;
    }
    // this.$data.managintab_statusall=!this.$data.managintab_statusall;
    }.bind(this), 500);
    //var tags_contac=(this as any).selectedContact.tags1;
    var tags_contac=this.$data.activetab=='details'?(this as any).selectedContact.tags1:this.$data.SelectedContInf.tags1;
       if(tags_contac.length!=0){
      (this as any).Tag_list_.forEach((e1)=>tags_contac.forEach((e2)=> {
          if(e1._id === e2._id){
          e2.select=true;
          }
      }
      ));
      }
   // this.$data.managintab=!this.$data.managintab;
  }
  
  contactdeatil_tag(tag ,evt){
    console.log('tag',tag);
    console.log('taglist',(this as any).Tag_list_);
     var found = (this as any).Tag_list_.find(function(element) {
        return element._id ==tag._id;
      });
      found.select=evt=="assign"?true:false;
      this.$data.Assigned_tag=evt=="assign"?tag._id:"";
      this.$data.managintab=false;
      //var tags_contacdetail=(this as any).selectedContact.tags1;
      var mna=(this as any).selectedContact;
      var tags_contacdetail=this.$data.activetab=='details' || this.$data.activetab=='textmsg'?(this as any).selectedContact.tags1:this.$data.SelectedContInf.tags1;

      if(evt=="assign"){
        if(tags_contacdetail.length!=0){
       tags_contacdetail.push(tag);
        }
        else{
          //tags_contacdetail=[tag];
         if(this.$data.activetab=='details' || this.$data.activetab=='textmsg'){ (this as any).selectedContact.tags1=[tag];} 
         else{ this.$data.SelectedContInf.tags1=[tag];}
        }
        if(this.$data.activetab=='details' || this.$data.activetab=='textmsg') this.updatetaglist( [tag._id],[])
      }
      else{
      var inx;
      tags_contacdetail.filter(function (el,index) { 
        if(el._id === tag._id){
          inx=index;
        }
     });
     tags_contacdetail.splice(inx,1); 
      if(this.$data.activetab=='details' || this.$data.activetab=='textmsg') this.updatetaglist([], [tag._id])

      }
    /* 
     If Active tab is Contact-detail,onchange of ManagingTag contact information has to Update
    */
     if(this.$data.activetab=='details'){
      (this as any).selectedContact.taglist=[];
        (this as any).selectedContact.tags1.forEach(element => {
           (this as any).selectedContact.taglist.push(element._id)
        });
       const payload = JSON.parse(JSON.stringify((this as any).selectedContact));
      this.$data.loadingg=true;
       this.$store.dispatch('assignTagtoContact', payload).then(r => { 
          this.$data.loadingg=false;
           this.$emit('updatecontact', 'UpdateContactInfo');
       }).catch(() => {
           this.$data.loadingg=false;
           this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
         });
     }
  }

  submitedit(e){
   this.$data.submitted=true;
   this.$data.editemail_status=false;
   var number_val = false;
    
   //var editemail_status=false;
   var bb=this.$data.SelectedContInf;
   let oldtaglist = this.$data.oldtaglist;
   this.$validator.validate().then(valid => {
     
    if(valid)    
         if(this.$data.SelectedContInf.email[0]!="")
        {
           this.$data.editemail_status=!this.validateEmail(this.$data.SelectedContInf.email)?true:false;//true;
        }
        let wordvalidate = this.editworkdatacheck();
        let workval = JSON.parse(JSON.stringify(wordvalidate)).type;
        let workpos = JSON.parse(JSON.stringify(wordvalidate)).position;
        let homevalidate = this.$data.SelectedContInf.home  ? !(this.validatePhoneNumber( this.$data.SelectedContInf.home) != 'Invalid number' ): (this.$data.SelectedContInf.numbers.mobile.number || this.workeditdatacheck()) ? false : true; 
        let workvalidate = this.workeditdatacheck() ? !(workval ? false : true  ): (this.$data.SelectedContInf.home || this.$data.SelectedContInf.numbers.mobile.number) ? false : true;
        let mobilevalidate =this.$data.SelectedContInf.numbers.mobile.number  ? !(this.validatePhoneNumber( this.$data.SelectedContInf.numbers.mobile.number) != 'Invalid number' ): (this.$data.SelectedContInf.home || this.workeditdatacheck()) ? false : true;
        if(!homevalidate && !workvalidate && !mobilevalidate)
        {
           number_val = true;
        }
       
        debugger
      if( number_val && valid && !this.$data.editemail_status ){ 
        var USERID=(this as any).User_id; 
       const payload = JSON.parse(JSON.stringify(this.$data.SelectedContInf));
        payload.imageUrl      = this.$data.SelectedContInf.imageUrl,  
        payload.first_name    = this.$data.SelectedContInf.first_name,
        payload.last_name     = this.$data.SelectedContInf.last_name,
        payload.compny_name   = this.$data.SelectedContInf.compny_name, 
        payload.address       = this.$data.SelectedContInf.address,
        payload.custermerid   = this.$data.SelectedContInf.custermerid,
        payload.work          = this.$data.SelectedContInf.work,
        payload.home          = this.$data.SelectedContInf.home,
        payload.mobile        = this.$data.SelectedContInf.numbers.mobile.number,
        payload.email         = this.$data.SelectedContInf.email
        
        var incre_decr=(this as any).FavoirteContact_Count;
      if((this as any).SelectedContInf.pvt_cont){
      if( this.$data.SelectedContInf.Favoritecontact!=undefined && this.$data.SelectedContInf.Favoritecontact.length!=0 ){
          var Exist_UserId = this.$data.SelectedContInf.Favoritecontact.filter(function (el) {
            return el == USERID;
            });
            if(Exist_UserId.length==0){
              incre_decr=incre_decr+1;//'increase';
              payload.Favoritecontact.push(USERID);
            }
        }
        else{
          incre_decr=incre_decr+1;//'increase';
          payload.Favoritecontact=[USERID];
        }
      }  
      else{
      if(this.$data.SelectedContInf.Favoritecontact!=undefined && this.$data.SelectedContInf.Favoritecontact.length!=0 ){
            var Exist_UserId = this.$data.SelectedContInf.Favoritecontact.filter(function (el,index) {
                if(el==USERID){
                incre_decr=incre_decr-1;//'decrease';
                payload.Favoritecontact.splice(index,1);
                }
            });
        }
        }
       let addtaglist = [];
       let removetaglist = [];
      if(this.$data.SelectedContInf.tags1!=undefined){
          payload.taglist=[];
          this.$data.SelectedContInf.tags1.filter(function (element) { 
          payload.taglist.push(element._id)
          if(oldtaglist.indexOf(element._id) == -1) addtaglist.push(element._id)
      });
       } 
    for(let i = 0; i < oldtaglist.length; i++)
    {
      if(payload.taglist.indexOf(oldtaglist[i]) == -1) removetaglist.push(oldtaglist[i])
    }
    
this.updatetaglist(addtaglist, removetaglist);
    
      this.$data.loadingg=true;
      this.$store.dispatch('submitContactChanges', payload).then(r => {  
      this.$data.editstatus=false;
      this.$data.activetab='details';
      this.$store.commit('FAVORITECONTACT_COUNT',incre_decr);
      this.$emit('updatecontact', 'UpdateContactInfo');
      this.contact_infor();
      this.$data.loadingg=false;
       
       }).catch(() => {
           this.$data.loadingg=false;
           this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
         });
        }
        
    });
  }
  updatetaglist(add, remove)
  {
      let tags = util.handletag();
      if(add.length > 0)
      {
        for(let i = 0; i < add.length; i++)
        {
        let addi = tags.map(e=>e._id).indexOf(add[i]);
        addi > -1 && tags[addi].contact_count ? tags[tags.map(e=>e._id).indexOf(add[i])].contact_count += 1 : 0;
        }
      }
      if(remove.length > 0)
      {
        for(let i = 0; i < remove.length; i++)
        {
          let remi = tags.map(e=>e._id).indexOf(remove[i]);
          remi > -1 && tags[remi].contact_count ? tags[tags.map(e=>e._id).indexOf(remove[i])].contact_count -= 1 : 0;
        }
      }
      util.handletag(tags, 'set');
      this.$store.commit('TAB_STATUS' ,!(this as any).tagstatus);
  }


  }
